// extracted by mini-css-extract-plugin
export default {"descriptionWrapper":"Jelyv"};